// export const SERVER = 'development';
export const SERVER = 'production';

// propa-development
const firebaseConfigDEV = {
  apiKey: 'AIzaSyDt2YW8tzvS-vrTDJjHdkZaPB7GA0YAIgY',
  authDomain: 'propa-development.firebaseapp.com',
  projectId: 'propa-development',
  storageBucket: 'propa-development.appspot.com',
  messagingSenderId: '357257558110',
  appId: '1:357257558110:web:86500126f4682d805b1ccf',
  measurementId: 'G-QSVCDK2297',
};

// propa
const firebaseConfigPROD = {
  apiKey: 'AIzaSyAVgPzaXxiaWiH-6g_xgQFzeluOSJpQLfI',
  authDomain: 'propa-d9670.firebaseapp.com',
  databaseURL: 'https://propa-d9670.firebaseio.com',
  projectId: 'propa-d9670',
  storageBucket: 'propa-d9670.appspot.com',
  messagingSenderId: '131782111383',
  appId: '1:131782111383:web:0bd85db59eca85af26b9d2',
  measurementId: 'G-CD6J9PD2BQ',
};

export const firebaseConfig =
  SERVER === 'production' ? firebaseConfigPROD : firebaseConfigDEV;

export const supportEmail = 'support@propa.co.uk';

export const supportLink = `mailto:${supportEmail}`;

export const TDSlink = 'https://www.tenancydepositscheme.com/';

export const privacyPolicyLink = 'https://propa.co.uk/legal/app/privacy-policy';

export const termsAndConditionsLink =
  'https://propa.co.uk/legal/app/terms-and-conditions';

export const supportLinkSite = 'https://support.propa.co.uk';

export const propaLandingLink = 'https://propa.co.uk';

export const picturesMaxSize = {
  profile: 700,
  id: 1250,
  property: 2000,
  message: 1000,
};

export const storageKey = '__propa-storage__';

export const maxRecentStorage = 10;

// Currently this key is onlu for localhost and propa-development env
export const reCAPTCHAKey =
  SERVER === 'production'
    ? '6LeAQzUoAAAAAAE0miZwGvdyt3Rz7q_35EFMoHjz'
    : '6LeA9PEcAAAAAMm8nRcZQlt-Pv2C1Upx2BLxzL_3';

export const tdsLink = 'https://www.tenancydepositscheme.com';

export const leaveAReviewUrl = 'https://uk.trustpilot.com/evaluate/propa.co.uk';

export const mobileBreakpoint = 480;

export const stripeProductPaymentLinks = {
  tenancyManagement: 'https://buy.stripe.com/4gw1568iEc4c4Bq3cn',
  tenantFind: 'https://buy.stripe.com/14k0120Qcgks7NC6oF',
  photography: 'https://buy.stripe.com/7sI8xy56s4BKgk8eVa',
  model: 'https://buy.stripe.com/28oaFG7eA1py1pebIX',
  epc: 'https://buy.stripe.com/3cs5lm9mI0lu1pe8wK',
  eicr: 'https://buy.stripe.com/00gaFG0Qc4BK9VK9AN',
  gsc: 'https://buy.stripe.com/3cs5lm1Ug6JS3xmdR2',
};

export const companiesHouseUrl =
  'https://find-and-update.company-information.service.gov.uk';
